// Shared cart reads and bundled Shopify sections. No settled cart cache: prices,
// discounts and selling plans must always come from the current server response.
(function () {
  'use strict';
  var generation = 0;
  var inFlight = null;
  var drawerSections = ['cart-drawer', 'cart-icon-bubble'];

  function isFullCart(data) {
    return !!data && Array.isArray(data.items) && Number.isFinite(data.item_count) && Number.isFinite(data.total_price);
  }

  function invalidate() {
    generation += 1;
    inFlight = null;
  }

  function getCart(options) {
    if (options && options.fresh) invalidate();
    if (inFlight) return inFlight;
    var revision = generation;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var request = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart read failed');
        return response.json();
      })
      .then(function (cart) {
        if (revision !== generation) return getCart();
        if (!isFullCart(cart)) throw new Error('Incomplete cart response');
        return cart;
      })
      .finally(function () {
        if (inFlight === request) inFlight = null;
      });
    inFlight = request;
    return request;
  }

  function validSection(id, html) {
    if (typeof html !== 'string' || !html.trim()) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    if (id === 'cart-drawer') {
      return !!(doc.querySelector('#CartDrawer .drawer__inner') &&
        doc.querySelector('cart-drawer-items') && doc.querySelector('.cart-drawer__footer'));
    }
    return !!doc.querySelector('.shopify-section');
  }

  async function ensureSections(response, ids) {
    ids = Array.from(new Set(ids || drawerSections));
    var sections = Object.assign({}, response && response.sections);
    var missing = ids.filter(function (id) { return !validSection(id, sections[id]); });
    if (missing.length) {
      var url = new URL(window.location.href);
      url.searchParams.delete('section_id');
      url.searchParams.set('sections', missing.join(','));
      // Keep the page's Section Rendering API route. Accept: application/json
      // makes /cart return plain cart data and ignore the sections parameter.
      var result = await fetch(url.pathname + url.search);
      if (!result.ok) throw new Error('Cart sections read failed');
      var recovered = await result.json();
      // Accept either a section map or a cart response containing sections.
      var recoveredSections = recovered.sections || recovered;
      missing.forEach(function (id) { sections[id] = recoveredSections[id]; });
      if (missing.some(function (id) { return !validSection(id, sections[id]); })) {
        throw new Error('Cart sections unavailable: ' + missing.join(','));
      }
    }
    return Object.assign({}, response, { sections: sections });
  }

  async function renderDrawer(response) {
    var revision = generation;
    var state = await ensureSections(response);
    if (revision !== generation) return;
    var doc = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      // Read before replaceWith adopts these nodes into the live document.
      var empty = doc.querySelector('cart-drawer-items').classList.contains('is-empty');
      ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
        var target = drawer.querySelector(selector);
        var source = doc.querySelector(selector);
        if (target && source) target.replaceWith(source);
      });
      var inner = drawer.querySelector('.drawer__inner');
      drawer.classList.toggle('is-empty', empty);
      if (inner) {
        inner.classList.toggle('is-empty', empty);
        var oldWarning = inner.querySelector('.drawer__inner-empty');
        var newWarning = doc.querySelector('.drawer__inner-empty');
        if (oldWarning) oldWarning.remove();
        if (newWarning) inner.prepend(newWarning);
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      bubble.innerHTML = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section').innerHTML;
    }
    // The async drawer replacement may happen after the cartUpdate subscribers
    // painted the old nodes. Give the new bar the same complete server totals.
    if (isFullCart(state) && window.WoolieFreteMeta) window.WoolieFreteMeta.render(true, state);
    return state;
  }

  window.WoolieCart = {
    isFullCart: isFullCart,
    invalidate: invalidate,
    revision: function () { return generation; },
    getCart: getCart,
    validSection: validSection,
    ensureSections: ensureSections,
    renderDrawer: renderDrawer
  };
})();
